import {Controller} from "stimulus";
import createChannel from "channels/cable";

export default class extends Controller {
  static targets = ["contact", "queue"];

  initialize() {
    this.showing = true;
    let queueController = this;
    document.addEventListener('dashboard.detail.shown', function (e) {
      queueController.setVisibility(false);
    });
    document.addEventListener('dashboard.list.shown', function (e) {
      queueController.setVisibility(true);
    });
    this.dashboardChannel = createChannel("DashboardChannel", {
      connected() {
      },
      received(data) {
        if (data.reminder) {
          let remindersController = queueController.application.getControllerForElementAndIdentifier(document.getElementById('reminders'), 'reminders');
          remindersController.addReminder(data);
        }
        else {
          queueController.updateQueue(data);
        }
      }
    });
  }

  setVisibility(visible) {
    this.showing = visible;
    this.showQueue();
  }

  showQueue() {
    if (this.showing && this.contactTargets.length > 0) {
      this.element.style.display = 'block';
    }
    else {
      this.element.style.display = 'none';
    }
  }

  updateQueue(data) {
    console.log(data.status)
    if (data.status == 'on_call' || data.status == 'closed') {
      this.removeContact(data.id)
      document.dispatchEvent(new CustomEvent('dashboard.queue.remove', {detail:data.id}));
    }
    else {
      var element = this.findContact(data);
      if (element) {
        element.textContent = data.message
      }
      var contact = this.application.getControllerForElementAndIdentifier(document.getElementById('contact-detail'), 'contact');
      if (contact && contact.data.get('id') == data.id) {
        contact.setMessage(data.message);
      }
    }
  }

  findContact(contact) {
    for (var i = 0; i < this.contactTargets.length; i++) {
      if (this.contactTargets[i].dataset.id == contact.id) {
        return this.contactTargets[i];
      }
    }
    return this.createContact(contact);
  }

  createContact(contact) {
    $(this.queueTarget).prepend(contact.contact);
    this.showQueue();
  }

  removeContact(id) {
    for (var i = 0; i < this.contactTargets.length; i++) {
      if (this.contactTargets[i].dataset.id == id) {
        this.contactTargets[i].remove();
      }
    }
  }

}